import { Flame, GraduationCap, CheckCircle2, Lock, Bell, BellOff, LifeBuoy } from "lucide-react";
import { Link } from "react-router-dom";
import { StreakShareButton } from "@/components/StreakShare";

export const MemberStatusBar = ({ progress, onCheckin, onToggleReminder, onShareStreak }) => {
  if (!progress) return null;
  const pct = (progress.completed_count / progress.total_modules) * 100;
  return (
    <div
      data-testid="member-status-bar"
      className="tacc-card px-5 md:px-8 py-4 md:py-5 mb-6 flex flex-col md:flex-row md:items-center gap-4 md:gap-8"
    >
      <div className="flex items-center gap-3 shrink-0 flex-wrap">
        <Flame size={20} className={progress.streak_current > 0 ? "text-[#B45309]" : "text-[#78716C]"} strokeWidth={1.5} />
        <span className="font-display text-2xl leading-none" data-testid="statusbar-streak">{progress.streak_current}</span>
        <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#78716C] whitespace-nowrap">day streak</span>
        {progress.checked_in_today ? (
          <span data-testid="streak-checked-in" className="inline-flex items-center gap-1.5 font-mono text-[10px] tracking-[0.15em] uppercase text-emerald-400 ml-2 whitespace-nowrap">
            <CheckCircle2 size={12} /> Grounded today
          </span>
        ) : (
          <button onClick={onCheckin} data-testid="streak-checkin-btn" className="btn-ember text-xs ml-2 whitespace-nowrap !px-4 !py-2.5">
            <Flame size={12} /> Ground today
          </button>
        )}
        {progress.grace_pending && !progress.checked_in_today && (
          <span data-testid="streak-grace-pending" title="You missed yesterday. One grace day a month keeps the streak — ground today and it survives."
                className="inline-flex items-center gap-1.5 font-mono text-[9px] tracking-[0.15em] uppercase text-[#B45309] border border-[#F59E0B]/40 px-2 py-1 whitespace-nowrap">
            <LifeBuoy size={11} /> Grace day saves it — ground now
          </span>
        )}
        {!progress.grace_pending && progress.grace_available === false && (
          <span data-testid="streak-grace-used" title="Your one grace day this month has been used. It comes back next month."
                className="inline-flex items-center gap-1.5 font-mono text-[9px] tracking-[0.15em] uppercase text-[#A8A29E] whitespace-nowrap">
            <LifeBuoy size={11} /> Grace day used this month
          </span>
        )}
        <button
          onClick={onToggleReminder}
          data-testid="reminder-toggle"
          title={progress.daily_reminder ? "Daily reminder email is ON — click to turn off" : "Get a daily reminder email"}
          className={`w-8 h-8 rounded-full border flex items-center justify-center transition-colors ${
            progress.daily_reminder
              ? "border-[#F59E0B]/60 text-[#B45309] bg-[#F59E0B]/10"
              : "border-[#E7DFD5] text-[#78716C] hover:border-[#F59E0B] hover:text-[#B45309]"
          }`}
        >
          {progress.daily_reminder ? <Bell size={13} /> : <BellOff size={13} />}
        </button>
        <StreakShareButton streak={progress.streak_current} onClick={onShareStreak} />
      </div>

      <div className="flex-1 min-w-[160px]" data-testid="dashboard-progress">
        <div className="flex items-center justify-between mb-1.5">
          <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#78716C]">Progress Tracker</span>
          <span data-testid="dashboard-progress-count" className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#B45309]">
            {progress.completed_count} of {progress.total_modules} complete
          </span>
        </div>
        <div className="h-1.5 bg-black/5 rounded-full overflow-hidden">
          <div className="h-full bg-[#F59E0B] rounded-full transition-all duration-700" style={{ width: `${pct}%` }} />
        </div>
      </div>

      {progress.graduated ? (
        <Link to="/modules/graduation/watch" data-testid="statusbar-graduation-btn" className="btn-outline text-xs shrink-0">
          <GraduationCap size={14} /> Watch your graduation video
        </Link>
      ) : (
        <span data-testid="statusbar-graduation-locked" className="inline-flex items-center gap-1.5 font-mono text-[10px] tracking-[0.2em] uppercase text-[#78716C] shrink-0">
          <Lock size={12} /> Graduation at 8 of 8
        </span>
      )}
    </div>
  );
};
